import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { MainLayout } from '@/components/layout/main-layout';
import { isSessionAuthenticated } from '@/lib/auth-session';

export const Route = createFileRoute('/__authenticated')({
	beforeLoad: ({ context: { msal } }) => {
		if (!isSessionAuthenticated(msal)) {
			throw redirect({ to: '/sign-in', throw: true });
		}
	},
	component: () => (
		<MainLayout>
			<Outlet />
		</MainLayout>
	),
});
